import { defineAction, object } from '~/prix'
import seedStreetCollectionAction from './seedStreetCollection.action.json' with { type: 'json' }

const seedStreetCollectionDefinition = defineAction({
  ...seedStreetCollectionAction,
  input: object({}),
  output: object({}),
})

export default seedStreetCollectionDefinition
